import React, {useState} from 'react'
import { SendOutlined } from '@ant-design/icons'
import { Button, Input } from 'antd'
import style from './chat-bar.module.sass'
const { TextArea} = Input
import { useLlm } from './useLlm'

export const ChatBar = ({awaitingResponse, send}: Pick<ReturnType<typeof useLlm>, 'awaitingResponse' | 'send'>) => {
	const [inputValue, setInputValue] = useState('')
	

	const onSend = () => {
		send({content: inputValue})
		setInputValue('')
	}

	

	const handleKeyPress = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault()
			onSend()
		}
	}
	return (
		<div className={style.inputContainer}>
			<TextArea
				value={inputValue}
				onChange={(e) => setInputValue(e.target.value)}
				onKeyPress={handleKeyPress}
				placeholder="Ask me anything about this form..."
				autoSize={{ minRows: 1, maxRows: 2 }}
				className={style.messageInput}
				disabled={awaitingResponse}
				autoFocus={true}
			/>
			<Button
				type="primary"
				icon={<SendOutlined />}
				onClick={onSend}
				disabled={!inputValue.trim() || awaitingResponse}
				className={style.sendButton}
				size="small"
			/>
		</div>
	)
}